/**
 *    ____            _           _____
 *   / ___|    ___   | |   ___   |_   _|   ___    _ __    _   _
 *   \___ \   / _ \  | |  / _ \    | |    / _ \  | '_ \  | | | |
 *    ___) | | (_) | | | | (_) |   | |   | (_) | | | | | | |_| |
 *   |____/   \___/  |_|  \___/    |_|    \___/  |_| |_|  \__, |
 *  Created by Antonio Solo                               |___/
 *  Project & copyright: NSB.SU
 *
 */

import {CONSTANTS} from '@/constants';
import {functions} from '@/functions';
import miniToastr from "mini-toastr";

export const functions_tickets = {

    data: function () {
        return {
            ticket: null,
            tickets: [],
            tickets_loaded: false,
        };
    },

    methods: {

        /*
         *  Билеты
         */

        loadTicketsForVoucher: function (voucher_id, onSuccess = null, param = null) {
            if (voucher_id) {
                this.tickets = [];
                this.httpPrepare();
                let self=this;
                this.$http.get(this.apiurl('ticket/' + voucher_id + '/list')).then(function (response) {
                    response = this.httpSuccess(response);
                    self.tickets = response.payload;
                    this.executeFunction(onSuccess, param);
                }, function (error) {
                    this.error_log(error);
                })
            }
            return this;
        },


        resetTickets: function () {
            this.tickets = [];
            return this;
        },

        isTicketsLoaded: function () {
            return (this.tickets !== null) && this.tickets.length;
        },

        /*
         *  Билет
         */

        loadTicket: function (ticket_id, onSuccess = null, param = null) {
            console.log('loadTicket[1]=', ticket_id)
            if (!this.isTicketLoaded() && ticket_id) {
                console.log('loadTicket[2]=', ticket_id)
                this.ticket = null;
                this.httpPrepare();
                let self=this;
                this.$http.get(this.apiurl('ticket/' + ticket_id)).then(function (response) {
                    response = this.httpSuccess(response);
                    self.ticket = response.payload;
                    this.executeFunction(onSuccess, param, response.payload);
                }, this.httpError)
            }
            return this;
        },

        isTicketLoaded: function () {
            return (this.ticket !== null) && this.ticket;
        },

        resetTicket: function () {
            this.ticket = null;
            return this;
        },

        cancelTicket: function (ticket_id, onSuccess = null, param = null) {
            if (ticket_id) {
                let safe_ticket = this.ticket;
                this.ticket = null;
                this.httpPrepare();
                let self=this;
                this.$http.put(this.apiurl('ticket/' + ticket_id + '/cancel')).then(function (response) {
                    response = this.httpSuccess(response);
                    self.ticket = response.payload;
                    this.executeFunction(onSuccess, param);
                }, this.httpError)
            }
            return this;
        },

        uncancelTicket: function (ticket_id, onSuccess = null, param = null) {
            if (ticket_id) {
                let safe_ticket = this.ticket;
                this.ticket = null;
                this.httpPrepare();
                let self=this;
                this.$http.put(this.apiurl('ticket/' + ticket_id + '/uncancel')).then(function (response) {
                    response = this.httpSuccess(response);
                    self.ticket = response.payload;
                    this.executeFunction(onSuccess, param);
                }, this.httpError)
            }
            return this;
        },

        createTicket: function(voucher_id, ticket_data, onSuccess = null, param = null) {
            if (voucher_id) {
                this.tickets = [];
                this.httpPrepare();
                let self=this;
                this.$http.post(this.apiurl('ticket/' + voucher_id + '/create'), ticket_data).then(function (response) {
                    response = this.httpSuccess(response);
                    self.tickets = response.payload;
                    this.executeFunction(onSuccess, param);
                }, this.httpError)
            }
            return this;
        },

        saveTicket: function (onSuccess=null, param=null) {
            this.httpPrepare();
            let self=this;
            this.$http.put(this.apiurl('ticket/'+this.ticket.id+'/save'), this.ticket).then(function (response) {
                response = this.httpSuccess(response);
                this.executeFunction(onSuccess, param);
                miniToastr["success"]('Билет #'+self.ticket.id+' сохранен', null, 5000);
            }, this.httpError)
        },

        ticketType: function(ticket) {
            switch(ticket.type) {
                case 1: return "Билет на поезд";
                case 2: return "Билет на самолет";
                case 3: return "Бидет на автобус";
                case 4: return "Прочий транспорт";
                case 5: return "Прочие услуги";
                case 6: return "Туристические услуги";
                case 7: return "Экскурсионные услуги";
                default:return "Тип билета не выбран";
            }
        }

    },
};
